<template>
  <div id="down" ref="element">
    <!--导航-->
    <topHead ref="topHead"></topHead>
    <!--轮播-->
    <div class="block">
      <el-carousel height="550px" interval="5000" indicator-position="none">
        <el-carousel-item v-for="item in banner" :key="item.index">
          <span @click="windowOpen(item.url)">
            <img :src="item.picture">
          </span>
        </el-carousel-item>
      </el-carousel>
      <div class="downWare">
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6"></el-col>
          <el-col :span="3" class="down-set"><a>
            <el-icon class="el-icon-download"/>
            <span>WIN客户端下载</span></a></el-col>
          <el-col :span="4" class="down-set"><a>
            <el-icon class="el-icon-download"/>
            <span>快点打印驱动下载</span></a></el-col>
          <el-col :span="3" class="down-set"><a>
            <el-icon class="el-icon-download"/>
            <span>移动端下载</span></a></el-col>
          <el-col :span="6"></el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      banner: []
    }
  },
  created () {
    Api.changeClass = 3
    this.getBannerList()
    this.beforeMount()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },

    getBannerList () {
      axios.get(Api.bannerList + '?type=' + 3).then((response) => {
        this.banner = response.data
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .block {
    position: relative;
  }

  .el-carousel {
    width: 100%;
    height: 550px;
  }

  .el-carousel img {
    width: 100%;
    height: 100%;
  }

  .is-active .el-carousel__button {
    background-color: #00f1ff;
  }

  .el-carousel__button {
    height: 5px;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .el-carousel__arrow:hover {
    background-color: #cf0631;
  }

  .downWare {
    width: 100%;
    position: absolute;
    bottom: 40px;
    z-index: 10;
  }

  .down-set a {
    width: 100%;
    background-color: #fa4848;
    height: 60px;
    border-radius: 8px;
    text-align: center;
  }

  .down-set a:hover {
    background-color: #bd0404;
  }

  .down-set span {
    font-size: 18px;
    color: #fff;
    position: relative;
    top: -5px;
    line-height: 60px;
  }

  .el-icon-download {
    color: #fff;
    font-size: 30px;
    line-height: 60px;
  }

  .main {
    width: 1200px;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
    margin-top: 120px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Down.vue